import { EnumAmazonMarketplace, EnumAmazonProduct } from '../index';


/**------------------------------------------------------
 * Helper Variables
 */

//** Shirt / Premium Shirt Variants */
const SHIRT_VARIANTS_EN			: string[] = ['shirt', 'tshirts', 'tshirts', 't-shirt', 't-shirts', 'shirts', 'tee', 'tees', 'tee shirt', 'tee shirts', 'tees shirt', 'tees shirts'];
const SHIRT_VARIANTS_DE			: string[] = ['shirt', 'tshirts', 'tshirts', 't-shirt', 't-shirts', 'shirts'];
const SHIRT_VARIANTS_FR			: string[] = ['chemise', 'shirt', 'tshirts', 'tshirts', 't-shirt', 't-shirts', 'shirts'];
const SHIRT_VARIANTS_ES			: string[] = ['camisa', 'shirt', 'tshirts', 'tshirts', 't-shirt', 't-shirts', 'shirts'];
const SHIRT_VARIANTS_IT			: string[] = ['camicia', 'shirt', 'tshirts', 'tshirts', 't-shirt', 't-shirts', 'shirts', 'maglietta'];

//** English for COM & UK */
const V_NECK_VARIANTS_EN		: string[] = ['v-neck', 'v neck', 'v necks', 'v-necks', 'neckline', 'neckline shirt', 'neckline tshirt', 'v neck tshirt', 'v neck shirt', 'v neck tee', 'v neck tees', 'neckline tee'];
const TANK_TOP_VARIANTS_EN		: string[] = ['tank top', 'top', 'tank tops', 'tops', 'tank', 'a-shirts tanks', 'tanks', 'sleeveless', 'summer tops', 'tank shirt', 'tank tshirt', 'tank shirts', 'tank tshirts'];
const LONG_SLEEVE_VARIANTS_EN	: string[] = ['longsleeve', 'long sleeve', 'long sleeve shirts', 'long sleeve tshirts', 'long sleeve shirt', 'long sleeve tshirt', 'longsleeve shirt', 'longsleeve tshirt', 'longsleeve shirts', 'longsleeve tshirts'];
const REGLAN_VARIANTS_EN		: string[] = ['reglan'];
const SWEATSHIRT_VARIANTS_EN	: string[] = ['sweatshirt', 'sweathirt hoodie', 'sweatshirt hoodies', 'sweatshirt hoody', 'pullover sweaters'];
const HOODIES_VARIANTS_EN		: string[] = ['hoodie', 'pullover hoodie', 'pullover hoodies', 'hoodies'];
const POP_SOCKET_VARIANTS_EN	: string[] = ['popsocket', 'pop socket'];
const PHONE_CASE_VARIANTS_EN	: string[] = ['phone case', 'iphone case', 'case for phone'];
const TOTE_BAG_VARIANTS_EN		: string[] = ['tote bag', 'jute tote bag', 'jute bag', 'jute bags', 'burlap bags', 'shopping cloth bags', 'bag', 'bags'];
const THROW_PILLOW_VARIANTS_EN	: string[] = ['throw pillow', 'throw pillows', 'pillows'];


/**------------------------------------------------------
 * Amazon Search Prefix/Postfixes
 * > for Suggestions
 */
export const AMAZON_SEARCH_SUGGESTIONS: TypeAmazonSearchSuggestions = {
	// cspell:disable
	[EnumAmazonMarketplace.COM]: {
		[EnumAmazonProduct.Shirt]		: SHIRT_VARIANTS_EN,
		[EnumAmazonProduct.PremiumShirt]: SHIRT_VARIANTS_EN,
		[EnumAmazonProduct.VNeck]		: V_NECK_VARIANTS_EN,
		[EnumAmazonProduct.TankTop]		: TANK_TOP_VARIANTS_EN,
		[EnumAmazonProduct.LongSleeve]	: LONG_SLEEVE_VARIANTS_EN,
		[EnumAmazonProduct.Raglan]		: REGLAN_VARIANTS_EN,
		[EnumAmazonProduct.Sweatshirt]	: SWEATSHIRT_VARIANTS_EN,
		[EnumAmazonProduct.Hoodie]		: HOODIES_VARIANTS_EN,
		[EnumAmazonProduct.PopSocket]	: POP_SOCKET_VARIANTS_EN,
		[EnumAmazonProduct.PhoneCase]	: PHONE_CASE_VARIANTS_EN,
		[EnumAmazonProduct.ToteBag]		: TOTE_BAG_VARIANTS_EN,
		[EnumAmazonProduct.ThrowPillow]	: THROW_PILLOW_VARIANTS_EN
	},
	[EnumAmazonMarketplace.CO_UK]: {
		[EnumAmazonProduct.Shirt]		: SHIRT_VARIANTS_EN,
		[EnumAmazonProduct.PremiumShirt]: SHIRT_VARIANTS_EN,
		[EnumAmazonProduct.VNeck]		: V_NECK_VARIANTS_EN,
		[EnumAmazonProduct.TankTop]		: TANK_TOP_VARIANTS_EN,
		[EnumAmazonProduct.LongSleeve]	: LONG_SLEEVE_VARIANTS_EN,
		[EnumAmazonProduct.Raglan]		: REGLAN_VARIANTS_EN,
		[EnumAmazonProduct.Sweatshirt]	: SWEATSHIRT_VARIANTS_EN,
		[EnumAmazonProduct.Hoodie]		: HOODIES_VARIANTS_EN,
		[EnumAmazonProduct.PopSocket]	: POP_SOCKET_VARIANTS_EN,
		[EnumAmazonProduct.PhoneCase]	: PHONE_CASE_VARIANTS_EN,
		[EnumAmazonProduct.ToteBag]		: TOTE_BAG_VARIANTS_EN,
		[EnumAmazonProduct.ThrowPillow]	: THROW_PILLOW_VARIANTS_EN
	},
	[EnumAmazonMarketplace.DE]: {
		[EnumAmazonProduct.Shirt]		: SHIRT_VARIANTS_DE,
		[EnumAmazonProduct.PremiumShirt]: SHIRT_VARIANTS_DE,
		[EnumAmazonProduct.VNeck]		: ['v-neck', 'v neck', 'v necks', 'v-necks', 'neckline', 'neckline shirt', 'neckline tshirt', 'v neck tshirt', 'v neck shirt', 'v ausschnitt shirts', 'v ausschnitt tshirts', 'v ausschnitt shirt', 'v ausschnitt tshirt'],
		[EnumAmazonProduct.TankTop]		: ['tank top', 'top', 'tank tops', 'tops', 'tank', 'achselshirt', 'untershirt', 'unterhemd', 'unterhemden', 'ärmellose', 'muskelshirt', 'fitnessshirt', 'sleeveless', 'tanktop'],
		[EnumAmazonProduct.LongSleeve]	: ['longsleeve', 'long sleeve', 'long sleeve shirts', 'long sleeve tshirts', 'long sleeve shirt', 'long sleeve tshirt', 'longsleeve shirt', 'longsleeve tshirt', 'longsleeve shirts', 'longsleeve tshirts', 'langarmshirt', 'langarm tshirt', 'langarmshirts', 'langarm tshirts'],
		[EnumAmazonProduct.Raglan]		: ['reglan'],
		[EnumAmazonProduct.Sweatshirt]	: ['sweatshirt', 'sweathirt hoodie', 'sweatshirt hoodies', 'sweatshirt hoody', 'pullover sweaters', 'pullover'],
		[EnumAmazonProduct.Hoodie]		: ['hoodie', 'pullover hoodie', 'pullover hoodies', 'hoodies', 'kapuzen hoodie', 'kapuzen pullover'],
		[EnumAmazonProduct.PopSocket]	: ['popsocket', 'pop socket'],
		[EnumAmazonProduct.PhoneCase]	: ['phone case', 'iphone case', 'handyhülle', 'handy hülle', 'iphone-hülle', 'iphone hülle'],
		[EnumAmazonProduct.ToteBag]		: ['tote bag', 'shopping bags', 'bag', 'bags'],
		[EnumAmazonProduct.ThrowPillow]	: ['throw pillow', 'throw pillows', 'pillows', 'wurfkissen', 'kissen']
	},
	[EnumAmazonMarketplace.FR]: {
		[EnumAmazonProduct.Shirt]		: SHIRT_VARIANTS_FR,
		[EnumAmazonProduct.PremiumShirt]: SHIRT_VARIANTS_FR,
		[EnumAmazonProduct.VNeck]		: ['v-neck', 'v neck', 'v necks', 'v-necks', 'neckline', 'neckline shirt', 'neckline tshirt', 'v neck tshirt', 'v neck shirt'],
		[EnumAmazonProduct.TankTop]		: ['tank top', 'top', 'tank tops', 'tops', 'tank', 'a-shirts tanks', 'tanks', 'sleeveless'],
		[EnumAmazonProduct.LongSleeve]	: ['longsleeve', 'long sleeve', 'long sleeve shirts', 'long sleeve tshirts', 'long sleeve shirt', 'long sleeve tshirt', 'longsleeve shirt', 'longsleeve tshirt', 'longsleeve shirts', 'longsleeve tshirts', 'manches longues', 'manche long', 'manche longue'],
		[EnumAmazonProduct.Raglan]		: ['reglan'],
		[EnumAmazonProduct.Sweatshirt]	: ['sweat-shirt', 'sweatshirt', 'sweathirt hoodie', 'sweatshirt hoodies', 'sweatshirt hoody', 'pullover sweaters'],
		[EnumAmazonProduct.Hoodie]		: ['hoodie', 'pullover hoodie', 'pullover hoodies', 'hoodies', 'sweat à capuche'],
		[EnumAmazonProduct.PopSocket]	: ['popsocket', 'pop socket'],
		[EnumAmazonProduct.PhoneCase]	: ['phone case', 'iphone case', 'étui pour téléphone portable', 'étui pour iphone'],
		[EnumAmazonProduct.ToteBag]		: ['tote bag', 'shopping bags', 'bag', 'bags', 'tragetasche', 'einkaufstaschen', 'tasche', 'taschen'],
		[EnumAmazonProduct.ThrowPillow]	: ['throw pillow', 'throw pillows', 'pillows', 'oreiller', 'oreillers']
	},
	[EnumAmazonMarketplace.IT]: {
		[EnumAmazonProduct.Shirt]		: SHIRT_VARIANTS_IT,
		[EnumAmazonProduct.PremiumShirt]: SHIRT_VARIANTS_IT,
		[EnumAmazonProduct.VNeck]		: ['v-neck', 'v neck', 'v necks', 'v-necks', 'neckline', 'neckline shirt', 'neckline tshirt', 'v neck tshirt', 'v neck shirt', 'v maglietta'],
		[EnumAmazonProduct.TankTop]		: ['tank top', 'top', 'tank tops', 'tops', 'tank', 'a-shirts tanks', 'tanks', 'sleeveless', 'summer tops', 'tank shirt', 'tank tshirt', 'tank maglietta', 'tank maglietta'],
		[EnumAmazonProduct.LongSleeve]	: ['manica lunga', 'longsleeve', 'long sleeve', 'long sleeve shirts', 'long sleeve tshirts', 'long sleeve shirt', 'long sleeve tshirt', 'longsleeve shirt', 'longsleeve tshirt', 'longsleeve shirts', 'longsleeve tshirts'],
		[EnumAmazonProduct.Raglan]		: ['reglan'],
		[EnumAmazonProduct.Sweatshirt]	: ['felpa', 'sweatshirt', 'sweathirt hoodie', 'sweatshirt hoodies', 'sweatshirt hoody', 'pullover sweaters'],
		[EnumAmazonProduct.Hoodie]		: ['felpa con cappuccio', 'hoodie', 'pullover hoodie', 'pullover hoodies', 'hoodies'],
		[EnumAmazonProduct.PopSocket]	: ['popsocket', 'pop socket'],
		[EnumAmazonProduct.PhoneCase]	: ['phone case', 'iphone case', 'custodia per cellulare', 'custodia per iphone'],
		[EnumAmazonProduct.ToteBag]		: ['tote bag', 'shopping bags', 'bag', 'bags', 'borse della spesa', 'borsa', 'borse'],
		[EnumAmazonProduct.ThrowPillow]	: ['throw pillow', 'throw pillows', 'pillows', 'cuscino', 'cuscini']
	},
	[EnumAmazonMarketplace.ES]: {
		[EnumAmazonProduct.Shirt]		: SHIRT_VARIANTS_ES,
		[EnumAmazonProduct.PremiumShirt]: SHIRT_VARIANTS_ES,
		[EnumAmazonProduct.VNeck]		: ['v-neck', 'v neck', 'v necks', 'v-necks', 'neckline', 'neckline shirt', 'neckline tshirt', 'v neck tshirt', 'v neck shirt', 'camiseta cuello v'],
		[EnumAmazonProduct.TankTop]		: ['tank top', 'top', 'tank tops', 'tops', 'tank', 'a-shirts tanks', 'tanks', 'sleeveless', 'summer tops', 'tank shirt', 'tank tshirt', 'tank camiseta', 'tank camiseta'],
		[EnumAmazonProduct.LongSleeve]	: ['manga larga', 'camiseta manga larga', 'longsleeve', 'long sleeve', 'long sleeve shirts', 'long sleeve tshirts', 'long sleeve shirt', 'long sleeve tshirt', 'longsleeve shirt', 'longsleeve tshirt', 'longsleeve shirts', 'longsleeve tshirts'],
		[EnumAmazonProduct.Raglan]		: ['reglan'],
		[EnumAmazonProduct.Sweatshirt]	: ['sudadera', 'sweatshirt', 'sweathirt hoodie', 'sweatshirt hoodies', 'sweatshirt hoody', 'pullover sweaters'],
		[EnumAmazonProduct.Hoodie]		: ['sudadera con capucha', 'hoodie', 'pullover hoodie', 'pullover hoodies', 'hoodies'],
		[EnumAmazonProduct.PopSocket]	: ['popsocket', 'pop socket'],
		[EnumAmazonProduct.PhoneCase]	: ['phone case', 'iphone case', 'caja del teléfono celular', 'caja del iphone'],
		[EnumAmazonProduct.ToteBag]		: ['tote bag', 'shopping bags', 'bag', 'bags', 'bolso de mano', 'bolsas de compras', 'bolsa', 'bolsos'],
		[EnumAmazonProduct.ThrowPillow]	: ['throw pillow', 'throw pillows', 'pillows', 'tirar almohada', 'tirar almohadas', 'almohadas']
	}
	// cspell:enable
};


/**------------------------------------------------------
 * Types
 */
export type TypeAmazonSearchSuggestions 		= Partial<Record<EnumAmazonMarketplace, TypeAmazonMarketplaceSuggestions>>;
export type TypeAmazonMarketplaceSuggestions 	= Partial<Record<EnumAmazonProduct, string[]>>;
